import PreferencesForm from "./PreferencesForm";
export default PreferencesForm;